import React from "react";

const DOMAIN_PRICE_RANGES = [
  [".co.za", "R100–R180"],
  [".org.za", "R110–R200"],
  [".net.za", "R110–R200"],
  [".web.za", "R110–R200"],
  [".com", "R320–R460"],
  [".org", "R350–R520"],
  [".net", "R370–R520"],
  [".africa", "R210–R400"],
  [".co.uk", "R210–R350"],
  [".online", "R575–R1,150"],
  [".store", "R690–R1,380"],
  [".shop", "R520–R1,035"],
  [".site", "R460–R1,035"],
  [".info", "R460–R865"],
  [".biz", "R400–R750"],
  [".io", "R1,035–R1,725"],
];

const DomainPriceNoticeModal = ({ onAcknowledge, onClose }) => (
  <div className="domain-price-modal-backdrop">
    <section
      className="domain-price-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="domain-price-modal-title"
      aria-describedby="domain-price-modal-description"
    >
      <h2 id="domain-price-modal-title">Estimated annual domain prices</h2>
      <p id="domain-price-modal-description">
        These estimated price ranges include VAT and are provided as a guide.
        Actual GoDaddy prices and domain availability may change before
        registration. The final availability and cost will be confirmed at
        registration.
      </p>
      <div className="domain-price-modal-table-scroll">
        <table>
          <thead>
            <tr>
              <th scope="col">Extension</th>
              <th scope="col">Estimated annual price (incl. VAT)</th>
            </tr>
          </thead>
          <tbody>
            {DOMAIN_PRICE_RANGES.map(([extension, price]) => (
              <tr key={extension}>
                <th scope="row">{extension}</th>
                <td>{price}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="domain-price-modal-actions">
        <button
          type="button"
          className="btn-secondary domain-price-modal-close"
          onClick={onClose}
        >
          Close
        </button>
        <button
          type="button"
          className="btn-primary domain-price-modal-acknowledge"
          onClick={onAcknowledge}
          autoFocus
        >
          I understand, Proceed
        </button>
      </div>
    </section>
  </div>
);

export default DomainPriceNoticeModal;
